import { useState } from 'react';
import PortalIdParser from 'PortalIdParser';
import { refreshCookie } from 'hub-http/auth';
import http from 'hub-http/clients/apiClient';
import { startTrial } from 'purchase-motions-api/mutation/startTrial';
import { TRIAL_STANDARD_DURATION, apiNameToTrialIds } from '../constants/trial';
export const useStartTrial = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const mutate = async ({
    apiName,
    duration = TRIAL_STANDARD_DURATION
  }) => {
    const currentDate = new Date();
    const endDate = currentDate.setDate(currentDate.getDate() + duration).valueOf();
    const trialId = [apiNameToTrialIds[apiName]];

    // Remove Zorse ISC chat eligibility cache, so users get the right version of the Zorse widget immediately upon trial activation
    try {
      localStorage.removeItem('hubspot:isc:userIsEligibleForIscChat');
    } catch (e) {
      // Noop
    }
    setLoading(true);
    try {
      setData(await startTrial({
        trialId,
        endDate
      }));
      await new Promise(resolve => setTimeout(resolve, 3000)); // Timeout for 3 secs to allow parcels to provision before invalidating cache/refreshing cookie. This is a stopgap until Mon BE can modify the trial activation endpoint to wait to return success until the scopes are properly provisioned. Once that change is made, we can remove the timeout logic from here
      void http.delete('/navconfig/v5/navconfig/cache'); // Reset the nav cache so users can see updated nav options immediately
      void refreshCookie(PortalIdParser.get(), true); // Refresh cookie so /login-verify/hub-user-info starts returning new scopes immediately
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };
  return [mutate, {
    data,
    error,
    loading
  }];
};